import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useSearchParams } from "react-router-dom-v5-compat";
import type { AppDispatch } from "@b2bportal/core-types";

import { ensureFunnel, HotelNavigationUtility } from "@overrides/utilities";
import { useIsSameSearch, useHotelsConfig } from "@tenant/hotels";
import { initializeHotels } from "../../../store";
import type { AvailabilityPageFetchProps } from "../types";

export const useAvailabilityPageFetch = (props: AvailabilityPageFetchProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const isSameSearch = useIsSameSearch();
  const [searchParams] = useSearchParams();
  const config = useHotelsConfig();

  const location = useLocation();

  // Seeds a funnel ID when landing on the results page without one (e.g. a
  // deep link), so shopping events are always attributable to a funnel.
  useEffect(() => {
    ensureFunnel(
      "lodging",
      HotelNavigationUtility.getHotelFunnelSearch(
        `${location.pathname}${location.search}`
      )
    );
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (!isSameSearch) {
      //TODO: remove dependency on search params and use props
      dispatch(
        initializeHotels({
          searchParams,
          location: props.location,
          config,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSameSearch, config]);
};
